import {get, post} from 'external/axios';

export class SupportService {
    async sendEmail(response) {
        return post('/homeschooler/send-email', response);
    }
}

export const supportService = new SupportService();